// Cookiebar script
const cookieBar = document.getElementById('cookie-banner')
const cookieAccept = document.querySelector('.accept-cookies')
const closeCookieBar = document.querySelector('.btn-close-cookie')
const storage = localStorage.getItem('cookiebar')

if (cookieBar) {
    cookieBar.style.display = "block";

    if (storage === 'show') {
        cookieBar.style.display = "none";
    }

    cookieAccept.addEventListener("click", () => {
        window.localStorage.setItem('cookiebar', 'show');
        cookieBar.style.display = "none";
    })

    closeCookieBar.addEventListener("click", () => {
        cookieBar.style.display = "none";
    })

}